import Route from '@ember/routing/route';

export default class HotelSettingsMyotbPmsEligibilityRoute extends Route {}
